import type { Size } from "@/assets/icons/geist/Size";
import { InlineableSVG } from "@/components/InlineableSVG";
import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const IconError: FC<{ size: Size; inline?: boolean } & PropsWithClassName> = ({ size, inline, className }) => {
    switch (size) {
        case "sm":
            return (
                <InlineableSVG
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    inline={inline}
                >
                    <g clipPath="url(#clip0_313_3142)">
                        <path
                            d="M9.75 6.25L6.25 9.75"
                            stroke="currentColor"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M2.50849 10.7569C2.28968 10.5381 2.16672 10.2414 2.16666 9.93202V6.06802C2.16672 5.75863 2.28968 5.46193 2.50849 5.24319L5.24316 2.50852C5.4619 2.28971 5.7586 2.16675 6.06799 2.16669H9.93199C10.2414 2.16675 10.5381 2.28971 10.7568 2.50852L13.4915 5.24319C13.7103 5.46193 13.8333 5.75863 13.8333 6.06802V9.93202C13.8333 10.2414 13.7103 10.5381 13.4915 10.7569L10.7568 13.4915C10.5381 13.7103 10.2414 13.8333 9.93199 13.8334H6.06799C5.7586 13.8333 5.4619 13.7103 5.24316 13.4915L2.50849 10.7569Z"
                            stroke="currentColor"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6.25 6.25L9.75 9.75"
                            stroke="currentColor"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_313_3142">
                            <rect width="14" height="14" fill="white" transform="translate(1 1)" />
                        </clipPath>
                    </defs>
                </InlineableSVG>
            );
        case "base":
            return (
                <InlineableSVG
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    inline={inline}
                >
                    <g clipPath="url(#clip0_313_3148)">
                        <path
                            d="M12 8L8 12"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M3.72401 13.1506C3.47394 12.9007 3.33342 12.5616 3.33334 12.208V7.79198C3.33342 7.43839 3.47394 7.0993 3.72401 6.84931L6.84934 3.72398C7.09933 3.47391 7.43842 3.33339 7.79201 3.33331H12.208C12.5616 3.33339 12.9007 3.47391 13.1507 3.72398L16.276 6.84931C16.5261 7.0993 16.6666 7.43839 16.6667 7.79198V12.208C16.6666 12.5616 16.5261 12.9007 16.276 13.1506L13.1507 16.276C12.9007 16.526 12.5616 16.6666 12.208 16.6666H7.79201C7.43842 16.6666 7.09933 16.526 6.84934 16.276L3.72401 13.1506Z"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8 8L12 12"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_313_3148">
                            <rect width="16" height="16" fill="white" transform="translate(2 2)" />
                        </clipPath>
                    </defs>
                </InlineableSVG>
            );
        case "lg":
            return (
                <InlineableSVG
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    inline={inline}
                >
                    <g clipPath="url(#clip0_313_3154)">
                        <path
                            d="M14.25 9.75L9.75 14.25"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M4.9395 15.5445C4.65818 15.2633 4.50008 14.8818 4.5 14.484V9.516C4.50008 9.11821 4.65818 8.73674 4.9395 8.4555L8.4555 4.9395C8.73674 4.65818 9.11821 4.50008 9.516 4.5H14.484C14.8818 4.50008 15.2633 4.65818 15.5445 4.9395L19.0605 8.4555C19.3418 8.73674 19.4999 9.11821 19.5 9.516V14.484C19.4999 14.8818 19.3418 15.2633 19.0605 15.5445L15.5445 19.0605C15.2633 19.3418 14.8818 19.4999 14.484 19.5H9.516C9.11821 19.4999 8.73674 19.3418 8.4555 19.0605L4.9395 15.5445Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9.75 9.75L14.25 14.25"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_313_3154">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </InlineableSVG>
            );
    }
};
